import { getColors, SIZES } from '../constants';
import { DrawArea } from '../types';

/**
 * Рисует фоновый контейнер нотификации
 */
export function drawContainer(ctx: CanvasRenderingContext2D, area: DrawArea): void {
    ctx.fillStyle = getColors().containerBackground;
    ctx.beginPath();
    ctx.roundRect(area.x, area.y, area.width, area.height, SIZES.containerBorderRadius);
    ctx.fill();
}
